import Keyset from "@frog/source/utility/Keyset.js"

import pixel from "@frog/source/views/app/stage/pixel.js"

export default function WorldTerrain(stage) {
    const views = []
    // Keyset.forEach(stage.world.terrain, (terrain, key) => {
    //     // TODO: Create blocks for ALL blocks in the stack!! not just the top one
    //     // for(let z = 0; z < block.position.z; z += 1)
    //     if(terrain.position.z <= 0) {
    //         return
    //     }
    //     for(let z = terrain.position.z - 1; z >= 0; z -= 1) {
    //         views.push({
    //             "key": "world/terrain/" + key + "/z/" + z,
    //             "image": getBlockImage(terrain),
    //             // "image": getImage(terrain.position),
    //             "position": pixel("terrain", {
    //                 "x": terrain.position.x,
    //                 "y": terrain.position.y,
    //                 "z": z,
    //             })
    //         })
    //     }
    // })

    Object.values(stage.world.edges).forEach((edge, key) => {
        views.push({
            "key": "world/edges/" + key,
            "image": EDGES[edge.direction],
            "position": pixel("edge-block-" + edge.direction, {
                "x": edge.position.x,
                "y": edge.position.y,
                "z": edge.position.z,
            }),
        })
    })

    return views
}

// const EDGES = {
//     "east": require("@frog/source/images/ld47/half-block-edge-east.png").default,
//     "south": require("@frog/source/images/ld47/half-block-edge-south.png").default,
//     "north": require("@frog/source/images/ld47/half-block-edge-north.png").default,
//     "west": require("@frog/source/images/ld47/half-block-edge-west.png").default,
// }

function getImage({x, y}) {
    if(x % 2 == 0 && y % 2 != 0
    || x & 2 != 0 && y % 2 == 0) {
        // return require("@frog/source/images/map/grasslands/tilemaps/checkerboard/checkerboard_1.png")
    } else {
        // return require("@frog/source/images/map/grasslands/tilemaps/checkerboard/checkerboard_2.png")
    }
}

function getGridBlockImage({x, y}) {
    if(x % 2 == 0 && y % 2 != 0
    || x & 2 != 0 && y % 2 == 0) {
        // return ASSET_DOMAIN + "/assets/images/blocks/block-alt.png"
        // return require("@frog/source/assets/images/blocks/block-alt.png")
        // return require("@frog/source/images/ld47/block-a.png")
    } else {
        // return ASSET_DOMAIN + "/assets/images/blocks/block.png"
        // return require("@frog/source/assets/images/blocks/block.png")
        // return require("@frog/source/images/ld47/block-b.png")
    }
}

function getGridHalfBlockImage({x, y}) {
    if(x % 2 == 0 && y % 2 != 0
    || x & 2 != 0 && y % 2 == 0) {
        // return ASSET_DOMAIN + "/assets/images/blocks/half-block-alt.png"
        // return require("@frog/source/assets/images/blocks/half-block-alt.png")
    } else {
        // return ASSET_DOMAIN + "/assets/images/blocks/half-block.png"
        // return require("@frog/source/assets/images/blocks/half-block.png")
    }
}

function getGridEastRampImage({x, y}) {
    if(x % 2 == 0 && y % 2 != 0
    || x & 2 != 0 && y % 2 == 0) {
        // return require("@frog/source/images/east-ramp-alt.png")
    } else {
        // return require("@frog/source/images/east-ramp.png")
    }
}

function getGridNorthRampImage({x, y}) {
    if(x % 2 == 0 && y % 2 != 0
    || x & 2 != 0 && y % 2 == 0) {
        // return require("@frog/source/images/south-ramp-alt.png")
    } else {
        // return require("@frog/source/images/south-ramp.png")
    }
}

function getBlockImage(block) {
    if(block.position.z % 1 == 0) {
        // if(block.shape == "obstruction") return require("@frog/source/images/obstruction.png")
        return getGridBlockImage(block.position)
    }
    if(block.position.z % 1 == 0.5) {
        if(block.shape == "block") return getGridHalfBlockImage(block.position)
        if(block.shape == "east-ramp") return getGridEastRampImage(block.position)
        if(block.shape == "south-ramp") return getGridNorthRampImage(block.position)
    }
}
